import React from 'react';

const TableLegend = ({data}) => {
    return (
        <div className="text-center">
            <small>
                <i className={"text-[13px]"}>{data}</i>
            </small>
        </div>
    );
};

export default TableLegend;